import React from 'react';
// import { useNavigate } from 'react-router-dom';
import './ServicesAndStats.css';
// import img from "../Assessts/cybersecurity.png";
// import product1 from "../Assessts/productandservices1.png";
// import product2 from "../Assessts/productandservices2.png";

export default function ServicesAndStats() {
  // const navigate = useNavigate();

  // const services = [
  //   {
  //     title: 'Products',
  //     img: product1,
  //     path: '/OurProducts'
  //   },
  //   {
  //     title: 'Products We Deal',
  //     img: product2,
  //     path: '/ProductsWeDeal'
  //   },
  //   {
  //     title: 'Cybersecurity',
  //     img: img,
  //     path: '/cybersecurity'
  //   }
  // ];

  const stats = [
    { value: 76, label: 'HAPPY CUSTOMER' },
    { value: 11, label: 'YEAR OF EXPERIENCE' },
    { value: 41, label: 'TEAM' }
  ];

  return (
    <section className="services-section">
      <h2>
        <span> Our Products</span>
      </h2>

      {/* Services Cards */}
      {/* <div className="services-grid">
        {services.map((service, index) => (
          <div
            key={index}
            className="service-card"
            onClick={() => navigate(service.path)}
            style={{ cursor: 'pointer' }}
          >
            <img src={service.img} alt={service.title} />
            <h4>{service.title}</h4>
          </div>
        ))}
      </div> */}

      {/* Stats Bar */}
      <div className="stats-bar">
        {stats.map((stat, index) => (
          <div key={index} className="stats-item">
            <h2>{stat.value}</h2>
            <p>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
